import * as React from "react";
import classnames from "classnames";

interface Props
{
    label: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;

    offsetColumns?: number;
    className?: string;
    disabled?: boolean;
}

// TODO: get rid of this class. Use CheckboxGroup instead
export class FormCheckboxItem extends React.Component<Props, any>
{
    private static defaultProps: Partial<Props> = {
        offsetColumns: 4
    };

    render()
    {
        const { offsetColumns, className, disabled } = this.props;
        return (
            <div className={classnames("form-group", className)} >
                <div className={`col-sm-offset-${offsetColumns} col-sm-${12 - offsetColumns}`}>
                    <div className="checkbox">
                        <label>
                            <input disabled={disabled} type="checkbox" checked={this.props.checked} onChange={this.props.onChange} /> {this.props.label}
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Forms/FormCheckboxItem.tsx